import { TailwindColor, tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { VariantColor } from '@repo/toolkit/colors'

export enum StaffPaymentStatusEnum {
  PENDING = 'PENDING',
  EXPORTED = 'EXPORTED',
  VALIDATED = 'VALIDATED'
}

type StaffPaymentStatusOption = {
  label: string
  state: string
  color: TailwindColor
  bgColor: TailwindColor
  variant?: VariantColor
}

export const staffPaymentStatusEnumMapping: Record<
  StaffPaymentStatusEnum,
  StaffPaymentStatusOption
> = {
  [StaffPaymentStatusEnum.PENDING]: {
    label: 'En attente',
    state: 'Non préparé',
    color: tailwindColors.grey.DEFAULT,
    bgColor: tailwindColors.grey.light.DEFAULT
  },
  [StaffPaymentStatusEnum.VALIDATED]: {
    label: 'Virement validé',
    state: 'Validé',
    color: tailwindColors.green.DEFAULT,
    bgColor: tailwindColors.green.light.DEFAULT,
    variant: 'success'
  },
  [StaffPaymentStatusEnum.EXPORTED]: {
    label: 'Fichier virement exporté',
    state: 'Préparé',
    color: tailwindColors.orange.DEFAULT,
    bgColor: tailwindColors.orange.light.DEFAULT,
    variant: 'warning'
  }
}
